import TabMissionMeasure from './TabMissionMeasure';

export default TabMissionMeasure;
